<template>
<div>
    <ItemDescription></ItemDescription>
    <PaymentDescription></PaymentDescription>
</div>
</template>

<script>
import ItemDescription from './ItemDescription'
import PaymentDescription from './PaymentDescription'
export default {
    components:{
        ItemDescription,
        PaymentDescription
    }
}
</script>

<style>

</style>